import { request } from './request'
import { getListItem, getSiteMapsByIds } from './sitemap'
import { getCollectionBasicInfoByIds, getDetail } from './collections'
import _ from 'lodash'

export const getTmpList = (paramsData) => {
  const url = '/api/v1/templates'
  return request({
    url,
    method: 'get',
    params: paramsData
  })
}

export const saveTmpEdit = (data) => {
  const url = '/api/v1/templates/save'
  return request({
    url,
    data,
    method: 'post',
  })
}

export const postMessage = (iframe, data) => {
  console.log('postMessage====', data)
  data = _.cloneDeep(data)
  return iframe.contentWindow.postMessage(data, '*')
}

export const postHeaderMessage = async (iframe, data) => {
  data = _.cloneDeep(data)
  let menuList = []
  if (data.data.menuId != null && data.data.menuId !== '' && data.data.menuId !== 'create') {
    const menuRes = await getListItem({id: data.data.menuId})
    if (menuRes.data.code === 0 && menuRes.data.data && menuRes.data.data.menuList && menuRes.data.data.menuList.length) {
      menuList = menuRes.data.data.menuList
    }
  }
  data.data['menuList'] = menuList
  console.log('postHeaderMessage ====', data)
  return iframe.contentWindow.postMessage(data, '*')
}

export const postFooterMessage = async (iframe, data) => {
  data = _.cloneDeep(data)
  let menuList = []
  const menuRes = await getListItem({id: data.data.menuId})
  if (menuRes.data.code === 0) {
    menuList = menuRes.data.data.menuList
  }
  data.data['menuList'] = menuList
  console.log('postMessage====', data)
  return iframe.contentWindow.postMessage(data, '*')
}

export const postCollectionsMessage = async (iframe, data) => {
  data = _.cloneDeep(data)
  let collectionsData = []
  const ids = data.data.items.map(i => i.collectionId).filter(i => i).join(',')
  const collectionsRes = await getCollectionBasicInfoByIds(ids)
  if (collectionsRes.data.code === 0 && collectionsRes.data.data && collectionsRes.data.data.length > 0) {
    collectionsData = collectionsRes.data.data
  }
  let newItems = data.data.items.map(i => {
    const targetData = collectionsData.find(item => item.id === i.collectionId)
    i['collectionData'] = targetData
    return i
  })
  data.data.items = newItems
  console.log('postCollectionsMessage====', data)
  return iframe.contentWindow.postMessage(data, '*')
}

export const postFeaturedCollectionMessage = async (iframe, data) => {
  data = _.cloneDeep(data)
  let collectionData = {}
  if (data.data.collectionId && data.data.collectionId !== '') {
    const pageSize = (data.data.oneRowsNum * 2) || 12
    let params = { id: data.data.collectionId, pageNum: 1, pageSize }
    const collectionDetailRes = await getDetail(params)
    if (collectionDetailRes.data.code === 0 && collectionDetailRes.data.data && collectionDetailRes.data.data.productAndOptionsImgDto) {
      collectionData = collectionDetailRes.data.data
    }
  }
  data.data['collection'] = collectionData
  console.log('postFeaturedCollectionMessage====', data)
  return iframe.contentWindow.postMessage(data, '*')
}

export const postScrollMessage = async (iframe, data) => {
  data = _.cloneDeep(data)
  return iframe.contentWindow.postMessage(data, '*')
}

export const postSiteMapsMessage = async (iframe, data) => {
  data = _.cloneDeep(data)
  let siteMapsData = []
  const ids = data.data.menus.map(i => i.menuId).filter(i => i).join(',')
  if (ids) {
    const siteMapsRes = await getSiteMapsByIds(ids)
    if (siteMapsRes.data.code === 0) {
      siteMapsData = siteMapsRes.data.data
    }
  }

  const menusData = data.data.menus.map((i, iIndex) => {
    const targetData = siteMapsData.find(item => item.id === i.menuId)
    if (!targetData) return null

    return targetData
  })
  data.data['menusData'] = menusData
  console.log('postSiteMapsMessage====*********', data)
  return iframe.contentWindow.postMessage(data, '*')
}

export const getPublicSections = () => {
  const url = '/api/v1/templates/sections'
  return request({
    url,
    method: 'get',
  })
}

export const getTemplatesTypes = () => {
  const url = '/api/v1/templates/types'
  return request({
    url,
    method: 'get',
  })
}
